import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HistoryStatus, PRODUCT_HISTORY, ProductHistory, ProductsAvailed } from '../products-availed';
import { StylesStatus } from 'app/models/users/StylesStatus';
import { CommerceService } from 'app/services/commerce.service';
import { MessageService } from 'primeng/api';
import { DriverCommerceStatus, ProductDetail, CommerceHistory } from '../driver-commerce-dto';
import { Utils } from 'app/utils';
import { DomSanitizer } from '@angular/platform-browser';
import { DeductionFrequency } from '../driver-commerce-dto';
import { XpressUserService } from 'app/services';

@Component({
  selector: 'product-details',
  standalone: false,
  templateUrl: './product-details.component.html',
  styleUrl: './product-details.component.scss'
})
export class ProductDetailsComponent implements OnInit {
  @Input() commerceId!: number;
  @Output() goBackToDetails = new EventEmitter<boolean>();

  constructor(
    private commerceService: CommerceService,
    private messageService: MessageService,
    private sanitizer: DomSanitizer,
    private xpressUserService: XpressUserService
  ){}

  public responsiveOptions = [
    {
        breakpoint: '1199px',
        numVisible: 1,
        numScroll: 1
    },
    {
        breakpoint: '991px',
        numVisible: 2,
        numScroll: 1
    },
    {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1
    }
  ];
  productHistory: any;
  public historyCols: any[] = [
    { field: 'Date', header: 'Date', width: '20%' },
    { field: 'Activity', header: 'Activity', width: '20%' },
    { field: 'Reason', header: 'Reason', width: '20%' },
    { field: 'UpdatedBy', header: 'Updated By', width: '20%' },
    { field: 'Remarks', header: 'Remarks', width: '20%' }
  ];
  public loading: boolean = false;
  public product!: ProductDetail;

  isPdfViewable: boolean = false;
  safeUrl: any;

  productImages: string[] = [];
  productDocuments: string[] = [];
  deductionFrequency = DeductionFrequency;
  public isEditProductVisible: boolean = false;
  public isEditConfirmVisible: boolean = false;
  public activeIndex: number = 0;
  public commerceHistory = CommerceHistory;
  public userList: string[] = [];

  ngOnInit(): void {
    this.getProductDetails();
  }

  public getStatusStyles(status: any): StylesStatus {
    let backgroundColor: string;
    let textColor: string;
    switch (status) {
        case CommerceHistory.Created:
            backgroundColor = '#FCE6A4';
            textColor = '#7A5D00';
            break;
        case CommerceHistory.Released:
            backgroundColor = '#2ECC71';
            textColor = '#fff';
            break;
        case CommerceHistory.TermChange:
            backgroundColor = '#F5A623';
            textColor = '#7A3E00';
            break;
        case CommerceHistory.Paused:
            backgroundColor = '#6C757D';
            textColor = '#fff';
            break;
        case CommerceHistory.Cancelled:
            backgroundColor = '#F8D7DA';
            textColor = '#8B2C30';
            break;
        case CommerceHistory.Suspended:
            backgroundColor = '#D6E9F9';
            textColor = '#35657C';
            break;
        case CommerceHistory.Resume:
            backgroundColor = '#D4EFDF';
            textColor = '#2C6844';
            break;
        case CommerceHistory.BondRelease:
            backgroundColor = '#FADBD8';
            textColor = '#93313B';
            break;
        case CommerceHistory.Completed:
            backgroundColor = '#117A44';
            textColor = '#fff';
            break;
        default:
            backgroundColor = '';
            textColor = '';
    }

    return {
      backgroundColor,
      color: textColor
    };
  }

  public getStatusText(status: any): string {
      let statusText = '';
      switch (status) {
        case DriverCommerceStatus.PendingTopup:
            statusText = 'Pending Top-up';
            break;
        case DriverCommerceStatus.PendingRelease:
          statusText = 'Pending Release';
            break;
        case DriverCommerceStatus.Active:
          statusText = 'Active';
            break;
        case DriverCommerceStatus.Paused:
          statusText = 'Paused';
            break;
        case DriverCommerceStatus.Suspended:
          statusText = 'Suspended';
            break;
        case DriverCommerceStatus.Cancelled:
          statusText = 'Cancelled';
            break;
        case DriverCommerceStatus.Completed:
          statusText = 'Completed';
            break;
        default:
          statusText = '';
      }
      return statusText;
  }

  public getProductDetails(): void {
    this.loading = true;
    const dto =  {
        CommerceId: this.commerceId
    };
    this.commerceService.getProductDetail(dto, this.messageService)
        .then(data => {
            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.product = data.CommerceDetail;
            this.product.DateAvailed = Utils.utcToLocaleDateString(this.product.DateAvailed);
            this.product.StartDate = Utils.utcToLocaleDateString(this.product.StartDate);
            this.product.Document.map(d => {
              if(d.FileType === 1){
                this.productImages.push(d.Url);
              } else {
                this.productDocuments.push(d.Url);
              }
            });
            this.product.ChangeHistory.sort((a, b) => new Date(b.Date).getTime() - new Date(a.Date).getTime());
            this.loading = false;
        })
        .catch(err => {
            this.loading = false;
            throw err;
        });
  }

  goBack(){
    this.goBackToDetails.emit(false);
  }

  getSafeUrl(url: string) {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.isPdfViewable = true;
  }

  hideDialog(){
    this.isPdfViewable = false;
  }

  showEditProduct(){
    this.isEditProductVisible = true;
    this.activeIndex = 0;
  }

  hideEditProduct(event: boolean){
    this.isEditProductVisible = event;
  }

  hideConfirmProduct(event: boolean){
    this.isEditConfirmVisible = event;
    this.getProductDetails();
  }

  showConfirmProduct(event: boolean){
    this.isEditConfirmVisible = !event;
    this.isEditProductVisible = event;
  }

  backToDialog(event: boolean){
    this.isEditProductVisible = event;
    this.isEditConfirmVisible = !event;
    this.activeIndex = 1;
  }
}
